import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ReactSVG } from "react-svg";
import Button from "../../../../common/Button";
import NewToolTip from "../../../../common/New-ToolTip";

const EducationDialog = ({
  open = false,
  handleClose = () => {},
  confirmAction = () => {},
  onCross = () => {},
  className = "",
}) => {
  return (
    <Transition
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-100 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-300 ease-out"
      leaveFrom="transform scale-300 opacity-100"
      leaveTo="transform scale-100 opacity-0"
      className={"fixed z-[11]  top-0 left-0 w-full h-screen"}
      show={open}
    >
      <div
        className="fixed inset-0 bg-black/10 z-[1]"
        onClick={() => handleClose()}
        aria-hidden="true"
      />
      <Transition.Child
        enter="transition duration-300 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-300 ease-out"
        leaveFrom="transform scale-300 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className={`bg-white z-[2] flex w-[720px] flex-col gap-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl ${className} rounded-[40px]`}
      >
        <div className="flex flex-row w-full pt-2">
          <div className="px-4 pt-4 w-full flex items-center justify-center">
            <div className="absolute flex items-center justify-center mx-28 mb-4 rounded-full top-[-25%]">
              <div className="flex items-center justify-center h-[189px] w-[189px] bg-transparent rounded-full">
                <ReactSVG
                  src={"/icons/medication-edu-new.svg"}
                  className={`scale-[80%]`}
                />
              </div>
            </div>
            <button
              type="button"
              className="absolute flex items-center justify-center p-1 transition-all rounded-full max-w-8 cursor-pointer right-6 top-6 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
              onClick={() => onCross()}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="w-4 h-4" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div className="px-8 pt-12 pb-6">
          <div className="flex flex-col gap-6">
            <div className={`flex flex-col px-6 gap-6`}>
              <h3 className="flex justify-center text-3xl font-semibold text-REELTeal">
                Medication Education
              </h3>
              <div className={`flex flex-col gap-2`}>
                <h3 className="flex items-center text-xl font-semibold text-teal-300">
                  Improve chronic condition outcomes with medication therapy.
                </h3>
                <p className="flex items-center justify-center text-lg font-normal text-teal-300">
                  Learn more about your medications
                </p>
              </div>
            </div>

            <div className={`flex flex-col gap-4 items-center`}>
              <Button
                className="w-fit min-w-[480px]"
                type={"primary-outline"}
                text={"Book Follow Up"}
                onClick={() => {
                  handleClose();
                }}
                iconUrl={"/icons/medicalSummary/Notes/CalendarIcon.svg"}
              />
              <div className="print-version-coming-soon-anchor">
                <Button
                  className="w-fit min-w-[480px]"
                  type={"primary-outline"}
                  text={"Print Version"}
                  disabled={true}
                  onClick={() => {
                    // Intentionally blocked until feature is enabled
                  }}
                />
              </div>
              <NewToolTip
                id="print-version-coming-soon"
                place="bottom"
                offset={-6}
                anchorSelect=".print-version-coming-soon-anchor"
                render={() => (
                  <div className="bg-gray-10 text-base text-gray-700 px-3 py-2">
                    Coming Soon
                  </div>
                )}
              />
              <Button
                className="w-fit min-w-[480px]"
                type={"primary"}
                text={"Continue to Education"}
                onClick={() => {
                  confirmAction();
                }}
              />
            </div>
          </div>
          {
            <>
              <br />
            </>
          }
        </div>
      </Transition.Child>
    </Transition>
  );
};

export default EducationDialog;
